import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { FormSectionHeader } from "../../Shared/FormSectionHeader";

export const DispatchedActions = (collectedBy: string) => {
    return (<Card>
        <FormSectionHeader label="Dispatched" />
        <CardContent>
            <Typography variant="subtitle1">
                Dispatched materials were collected by <strong>{collectedBy}</strong>. For more information see signed dispatch notes.<br />
                <small>No further actions are available.</small>
            </Typography>
        </CardContent>
    </Card>);
};
